import { render, staticRenderFns } from "./ModalDual.vue?vue&type=template&id=64b0e632&scoped=true&"
import script from "./ModalDual.vue?vue&type=script&lang=js&"
export * from "./ModalDual.vue?vue&type=script&lang=js&"
import style0 from "./ModalDual.vue?vue&type=style&index=0&id=64b0e632&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b0e632",
  null
  
)

export default component.exports